import { mapOtsAvailability } from "@novelist/novum-novella-ui";
import * as DataStore from "../../data/DataStore";
import { performJsonpGetRequest } from "../../lib/HttpRequest";
import * as utility from "../../utility";
import { getOtsAvailabilityForResults } from "../OtsRequests";
import * as catalogUtility from "../../lib/CatalogLinkUtilities";
import { getPrimaryIsbn } from '../../data/TitleInfoSelector';

const acceleratedReaderCallbackName = "acceleratedReaderDataRetrievedCallback";


const generateAcceleratedReaderSearchUrl = (bookLevel, interestLevel) => {
	let profileData = DataStore.getProfileData();
	let isbnToExclude = getPrimaryIsbn(DataStore.getJsonData());
	const apiEndpoint = `${utility.getNovSchema()}${window.novSelect.baseUrl || DataStore.getBaseUrl()}/api/acceleratedreader/ByInterestAndBookLevel?`;
	const customerInfo = profileData && `profile=${profileData.Profile}&password=${profileData.Password}`;
	const searchTerms = `&bookLevel=${bookLevel}&interestLevel=`;
	const encodedInterestLevel = encodeURIComponent(interestLevel);
	const searchTermsToExclude = `&isbnToExclude=${isbnToExclude}`;
	const customLinkReplacements = `${DataStore.getCustLinks()}`;
	return encodeURI(`${apiEndpoint}${customerInfo}${searchTerms}`) + `${encodedInterestLevel}` + encodeURI(`${searchTermsToExclude}${customLinkReplacements}`);
}


const translateAcceleratedReaderToNovumData = (bookLevel, interestLevel, titles) => {
	return {
		bookLevel: bookLevel,
		interestLevel: interestLevel,
		titles: titles
	};
};

const acceleratedReaderPostAction = (bookLevel, interestLevel, data, finalCallback) => {
	let titles = data.Titles.map((title) => {
		return {
			ui: title.ui,
			mainTitle: title.full_title,
			author: title.full_author,
			bookjacketUrl: title.bookjacket_url ? title.bookjacket_url.url : null,
			catalogLinkUrl: title.is_held_locally === false ? null : catalogUtility.getTitleCatalogLink(title.links),
			description: title.description,
			isHeld: title.is_held_locally,
			availability: undefined
		};
	});
	
	if(titles){
		finalCallback(translateAcceleratedReaderToNovumData(bookLevel, interestLevel, titles));
	}
	if (titles.length > 0) {
		if (data.OtsResultRelativeUrl) {
			Promise.resolve(getOtsAvailabilityForResults(data))
				.then((value) => {
					titles.map((item) => {
						let otsDataForTitle =
							value &&
							value.find((titleOts) => {
								return titleOts.key === item.ui;
							});
						item.availability = mapOtsAvailability(otsDataForTitle);
					});
					finalCallback(translateAcceleratedReaderToNovumData(bookLevel, interestLevel, titles));
				})
				.catch((err) => {
					finalCallback(translateAcceleratedReaderToNovumData(bookLevel, interestLevel, titles));
				});
		}
	}
};

export const getAcceleratedReaderSearchData = (bookLevel, interestLevel, finalCallback) => {
	let apiEndpoint = generateAcceleratedReaderSearchUrl(bookLevel,interestLevel);

	let callback = (data) => {
		acceleratedReaderPostAction(bookLevel, interestLevel, data, finalCallback);
	};

	utility.attachFunctionToCallback(callback, acceleratedReaderCallbackName);

	performJsonpGetRequest(apiEndpoint, acceleratedReaderCallbackName);
};




// WEBPACK FOOTER //
// ./src/data/services/AcceleratedReaderService.js